<template>
  <v-dialog v-model="isOpen" width="500">
    <v-card :class="`${arabic ? 'arFont': 'enFont'}`">
      <v-card-title class="text-h5 grey lighten-2">
        Add new evaluation
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            Hello world
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    isOpen: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("closeDialog");
      },
    },
  },
};
</script>
